export function addUrlParamsToUrl(
	searchParams: URLSearchParams,
	url = location.href
) {
	const task = (value: string, key: string, params: URLSearchParams) => {
		params.set(key, value);
	};
	return doTaskOnUrl(url, searchParams, task);
}
export function removeUrlParamsFromUrl(
	searchParams: URLSearchParams,
	url = location.href
) {
	const task = (_value: string, key: string, params: URLSearchParams) => {
		params.delete(key);
	};
	return doTaskOnUrl(url, searchParams, task);
}
function doTaskOnUrl(
	url: string,
	searchParams: URLSearchParams,
	task: (_value: string, key: string, params: URLSearchParams) => void
) {
	const urlSplitOnSearch = url.split('?');
	const params = new URLSearchParams(urlSplitOnSearch[1] || '');
	searchParams.forEach((value, key) => task(value, key, params));
	const paramsAsString = params.toString();
	const newUrl =
		urlSplitOnSearch[0] + (paramsAsString ? '?' + paramsAsString : '');
	return newUrl;
}
